module.exports = __webpack_public_path__ + "img/download-icon-white.1463b9b0.svg";